import { useState } from 'react';
import { Container, Row, Col, Card, Button, Badge, Accordion } from 'react-bootstrap';
import { FaUtensils, FaFire, FaFish, FaDrumstickBite, FaIceCream, FaStar, FaTag } from 'react-icons/fa';
import { 
    traditionalMehndiMenus, 
    bbqMenu, 
    desiMenu, 
    desserts, 
    baratWalimaMenus, 
    muttonMenu, 
    seaFoodMenu, 
    chineseMenu, 
    friedDryMenu, 
    othersMenu, 
    ronaqPremiumMenus 
} from '../../../data/menus';
import { colors } from '../../../utils/Colors';

const Menus = () => {
    const [activeKey, setActiveKey] = useState('traditional');

    const menuCategories = [
        { 
            key: 'traditional', 
            title: 'Traditional Mehndi', 
            icon: <FaUtensils />, 
            data: traditionalMehndiMenus,
            color: '#4CAF50'
        },
        { 
            key: 'barat', 
            title: 'Barat/Walima', 
            icon: <FaStar />, 
            data: baratWalimaMenus,
            color: '#9C27B0'
        },
        { 
            key: 'premium', 
            title: 'RONAQ Premium', 
            icon: <FaStar />, 
            data: ronaqPremiumMenus,
            color: '#FFC107'
        },
        { 
            key: 'bbq', 
            title: 'BBQ Special', 
            icon: <FaFire />, 
            data: bbqMenu,
            color: '#FF5722'
        },
        { 
            key: 'desi', 
            title: 'Desi Cuisine', 
            icon: <FaDrumstickBite />, 
            data: desiMenu,
            color: '#795548'
        },
        { 
            key: 'mutton', 
            title: 'Mutton Special', 
            icon: <FaDrumstickBite />, 
            data: muttonMenu,
            color: '#D32F2F'
        },
        { 
            key: 'seafood', 
            title: 'Sea Food', 
            icon: <FaFish />, 
            data: seaFoodMenu,
            color: '#2196F3'
        },
        { 
            key: 'chinese', 
            title: 'Chinese', 
            icon: <FaUtensils />, 
            data: chineseMenu,
            color: '#F44336'
        },
        { 
            key: 'fried', 
            title: 'Fried & Dry', 
            icon: <FaFire />, 
            data: friedDryMenu,
            color: '#FF9800'
        },
        { 
            key: 'desserts', 
            title: 'Desserts', 
            icon: <FaIceCream />, 
            data: desserts,
            color: '#E91E63'
        },
        { 
            key: 'others', 
            title: 'Others', 
            icon: <FaUtensils />, 
            data: othersMenu,
            color: '#607D8B'
        }
    ];

    const formatCurrency = (amount) => {
        if (!amount) return 'Rs 0';
        if (typeof amount === 'string') return amount;
        return `Rs ${new Intl.NumberFormat('en-PK').format(amount)}`;
    };

    const PackageCard = ({ pkg }) => (
        <Card className="h-100 package-card border-0 shadow-lg">
            <Card.Header className="text-center py-3" style={{ 
                backgroundColor: '#4CAF50', 
                color: 'white',
                borderBottom: 'none'
            }}>
                <h4 className="mb-0 fw-bold">{pkg.title}</h4>
             
            </Card.Header>
            <Card.Body className="py-4">
                <ul className="list-unstyled mb-0">
                    {pkg.items.map((item, index) => (
                        <li key={index} className="mb-2 d-flex align-items-start">
                            <FaTag className="me-2 mt-1" style={{ color: '#4CAF50', fontSize: '0.8rem' }} />
                            <span>{item}</span>
                        </li>
                    ))}
                </ul>
            </Card.Body>
        </Card>
    );

    const MenuItemCard = ({ item }) => (
        <Card className="h-100 menu-item-card border-0 shadow-sm">
            <Card.Body className="py-3">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="fw-bold mb-0" style={{ flex: 1 }}>{item.name}</h6> 
                </div>
                {item.id && (
                    <small className="text-muted d-block mt-1">Item #{item.id}</small>
                )}
            </Card.Body>
        </Card>
    );

    const renderMenuContent = () => {
        const currentCategory = menuCategories.find(cat => cat.key === activeKey);
        
        if (!currentCategory) return null;

      
        const isPackageMenu = ['traditional', 'barat', 'premium'].includes(activeKey);

        if (isPackageMenu) {
            return (
                <div className="menu-packages-section">
                    <div className="d-flex align-items-center mb-4">
                        <div className="me-3" style={{ color: currentCategory.color, fontSize: '1.8rem' }}>
                            {currentCategory.icon}
                        </div>
                        <div>
                            <h2 className="mb-1 fw-bold">{currentCategory.title}</h2>
                            <p className="text-muted mb-0">
                                Complete packages for your special occasion
                            </p>
                        </div>
                    </div>
                    
                    <Row className="g-4">
                        {currentCategory.data.map((pkg, index) => (
                            <Col lg={6} key={index}>
                                <PackageCard pkg={pkg} />
                            </Col>
                        ))}
                    </Row>
                </div>
            );
        } else {
            return (
                <div className="menu-items-section">
                    <div className="d-flex align-items-center mb-4">
                        <div className="me-3" style={{ color: currentCategory.color, fontSize: '1.8rem' }}>
                            {currentCategory.icon}
                        </div>
                        <div>
                            <h2 className="mb-1 fw-bold">{currentCategory.title}</h2>
                            <p className="text-muted mb-0">
                                {currentCategory.data.length} items available
                            </p>
                        </div>
                    </div>
                    
                    <Row className="g-3">
                        {currentCategory.data.map((item, index) => (
                            <Col lg={4} md={6} key={index}>
                                <MenuItemCard item={item} />
                            </Col>
                        ))}
                    </Row>
                </div>
            );
        }
    };

    return (
        <div className="menus-page py-5" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
                
                <div className="text-center mb-5">
                    <h1 className="display-5 fw-bold mb-3 " style={{color : colors.PRIMARY}}>RONAQ Banquet Menus</h1>
                    <p className="lead text-muted mb-4">
                        Premium catering services for weddings, corporate events, and celebrations
                    </p>
                    
                    <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
                        {menuCategories.slice(0, 3).map(category => (
                            <Badge
                                key={category.key}
                                bg={activeKey === category.key ? 'warning' : 'secondary'}
                                className="px-3 py-2 fs-6 rounded-pill cursor-pointer"
                                onClick={() => setActiveKey(category.key)}
                                style={{ cursor: 'pointer' }}
                            >
                                {category.icon} {category.title}
                            </Badge>
                        ))}
                    </div>
                </div>

               
                <div className="d-lg-none mb-4">
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <FaUtensils className="me-2" /> All Menu Categories
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="d-flex flex-wrap gap-2">
                                    {menuCategories.map(category => (
                                        <Button
                                            key={category.key}
                                            variant={activeKey === category.key ? 'warning' : 'outline-secondary'}
                                            size="sm"
                                            className="rounded-pill"
                                            onClick={() => setActiveKey(category.key)}
                                        >
                                            {category.title}
                                        </Button>
                                    ))}
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>

                
                <div className="d-none d-lg-block mb-5">
                    <div className="menu-tabs-wrapper bg-white rounded shadow-sm p-3">
                        <div className="d-flex flex-wrap justify-content-center gap-2">
                            {menuCategories.map(category => (
                                <Button
                                    key={category.key}
                                    variant={activeKey === category.key ? 'warning' : 'outline-secondary'}
                                    className="rounded-pill px-4"
                                    onClick={() => setActiveKey(category.key)}
                                >
                                    {category.icon} {category.title}
                                </Button>
                            ))}
                        </div>
                    </div>
                </div>

                
                {renderMenuContent()}

               
            </Container>

            <style jsx="true">{`
                .package-card {
                    transition: all 0.3s ease;
                    border-radius: 15px;
                    overflow: hidden;
                }
                
                .package-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 30px rgba(0,0,0,0.15) !important;
                }
                
                .menu-item-card {
                    transition: all 0.3s ease;
                    border-radius: 10px;
                }
                
                .menu-item-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(0,0,0,0.1) !important;
                }
                
                .cursor-pointer {
                    cursor: pointer;
                }
                
                .menu-tabs-wrapper {
                    position: sticky;
                    top: 80px;
                    z-index: 100;
                }
                
                @media (max-width: 768px) {
                    .display-5 {
                        font-size: 2rem;
                    }
                    
                    .lead {
                        font-size: 1rem;
                    }
                    
                    .package-card {
                        margin-bottom: 20px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Menus;